import type { CalendarEventObject } from '../CalendarSync'

/** Auto refresh 간격 옵션 */
export type RefreshInterval = 'no' | 'every_hour' | 'every_day' | 'every_week'

/** ICS 구독 메타데이터 (settings에 저장) */
export interface ICSSubscription {
  id: string
  url: string
  displayName: string
  color: string
  refreshInterval: RefreshInterval
  lastSynced: string | null
  isSync: boolean
  timezone: string | null
}

/** 서버 동기화 대상 (lastSynced, timezone 제외) */
export type ServerSub = Omit<ICSSubscription, 'lastSynced' | 'timezone'>

export const REFRESH_INTERVALS: Record<RefreshInterval, number> = {
  no: 0,
  every_hour: 3600000,
  every_day: 86400000,
  every_week: 604800000,
}

/** _fetchAndParseICS의 반환 타입 */
export interface FetchResult {
  events: Record<string, CalendarEventObject>
  calendarName: string | null
  timezone: string | null
}
